/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "../state"
import Store from "../store"
export default {
  orderAdd({ commit }, textareaNot) {
    var vm = this;
    const soap = require("soap");
    const url = state.sistemAddress;
    // alert(textareaNot)
    const args = {

      token: "",
      SIPARISNOTU: textareaNot,
      CARIKOD: state.UserId,
    };
    //  console.log(args);
    soap.createClient(url, function (err, client) {
      client.B2B_INS_SIPARISKAYDET(args, function (err, result) {
        if (result.B2B_INS_SIPARISKAYDETResult == "-1") {
          Store.dispatch("logout");
          //this.$store.dispatch('login', payload)
        }
        vm.veriler = JSON.parse(result.B2B_INS_SIPARISKAYDETResult);
        // alert("kayıt")

        //   vm.$store.state.eCommerce.cartItems = vm.veriler;
        //  console.log("in")
        //   console.log(vm.veriler);
      });
    });
  },
  sendMail({ commit }, item) {
    var vm = this;
    const soap = require("soap");
    const url = state.sistemAddress;

    const args = {

      ALICI: "rsayran@gmail.com",
      MESAJ: '<body style="color:red;">red bold</body>',
      KONU: "konu",
    };
    console.log(args);
      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.mailGonderResult);
          // alert("kayıt")
  
          //   vm.$store.state.eCommerce.cartItems = vm.veriler;
          //  console.log("in")
          console.log(vm.veriler);
        });
      });
  },
  toggleItemInWishList({ commit }, item) {
    commit('TOGGLE_ITEM_IN_WISH_LIST', item)
  },
  toggleItemInCart({ getters, commit, dispatch }, item) {
    getters.isInCart(item.BARKOD) ? dispatch('removeItemInCard', item) : dispatch('additemInCart', item)
  },
  removeItemInCard({ commit }, item) {

    var vm = this;
    vm.productList = [];
    const soap = require("soap");
    const url = state.sistemAddress;
    const args = {
      token: "",
      BARKOD: item.BARKOD,
      STOCKNO: item.STOCKNO,
      STOCKNAME: item.STOCKNAME,
      KDV: item.KDV,
      ISKONTO: 0,
      ADET: 0,
      FIYAT: item.FIYAT,
      CARIKOD: state.UserId,
    };
    console.log("args")

    console.log(args)
    //  console.log(args);
    soap.createClient(url, function (err, client) {
      client.B2B_INS_SEPET(args, function (err, result) {
        if (result.B2B_INS_SEPETResult == "-1") {
          Store.dispatch("logout");
          //this.$store.dispatch('login', payload)
        }
        vm.veriler = JSON.parse(result.B2B_INS_SEPETResult);
        //   alert("in")
        //  console.log("update")
        //  vm.$store.state.eCommerce.cartItems = vm.veriler;
        //   console.log("in")
        console.log(vm.veriler);
      });
    });
  },
  additemInCart({ commit }, item) {
    //  console.log("actions")
    //  console.log(item);
    var vm = this;
    vm.productList = [];
    const soap = require("soap");
    const url = state.sistemAddress;
    vm.priceParseList = JSON.parse(item.price);
    vm.productPrice = vm.priceParseList[0].fiyat;

    const args = {

      token: "",
      BARKOD: item.barcode,
      STOCKNO: item.productCode,
      STOCKNAME: item.productName.replace("'", ""),
      KDV: item.vat,
      ISKONTO: 0,
      ADET: 1,
      FIYAT: vm.productPrice,
      CARIKOD: state.UserId,
    };
    // console.log(args);
    soap.createClient(url, function (err, client) {
      client.B2B_INS_SEPET(args, function (err, result) {
        if (result.B2B_INS_SEPETResult == "-1") {
          Store.dispatch("logout");
          //this.$store.dispatch('login', payload)
        }
        vm.veriler = JSON.parse(result.B2B_INS_SEPETResult);
        //  vm.$store.state.eCommerce.cartItems = vm.veriler;
        //  console.log("in")
        //  console.log(vm.veriler);
      });
    });
    //  commit('ADD_ITEM_IN_CART', vm.veriler)
  },
  updateItemQuantity({ commit }, payload) {
    // console.log("action")
    // console.log(payload.quantity)
    //  console.log(payload.item.ADET)
    var vm = this;
    vm.productList = [];
    const soap = require("soap");
    const url = state.sistemAddress;

    vm.tutar = payload.item.FIYAT * payload.quantity;
    vm.kdvTutar = parseFloat(parseFloat(payload.item.KDVTUTAR) * payload.quantity);

    const args = {
      token: "",
      BARKOD: payload.item.BARKOD,
      STOCKNO: payload.item.STOCKNO,
      STOCKNAME: payload.item.STOCKNAME,
      KDV: payload.item.KDV,
      ISKONTO: 0,
      ADET: payload.quantity,
      FIYAT: payload.item.FIYAT,
      CARIKOD: state.UserId,
    };
    //  console.log(args);
    soap.createClient(url, function (err, client) {
      client.B2B_INS_SEPET(args, function (err, result) {
        if (result.B2B_INS_SEPETResult == "-1") {
          Store.dispatch("logout");
          //this.$store.dispatch('login', payload)
        }
        vm.veriler = JSON.parse(result.B2B_INS_SEPETResult);
        //   alert("in")
        //  console.log("update")
        //  vm.$store.state.eCommerce.cartItems = vm.veriler;
        //   console.log("in")
        //  console.log(vm.veriler);
      });
    });
    //  commit('UPDATE_ITEM_QUANTITY', payload)
  }
}
